// extracted by mini-css-extract-plugin
module.exports = {"container":"yourmessage_container__3M-1Z","outer":"yourmessage_outer__2Mk9S"};